import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getAllCancelReasons } from '../api'

type Status = 'pending' | 'success' | 'fail' | 'idle'

export function useGetCancelReasonsOnMount(loadReasons: boolean) {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<Status>('idle')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('pending')
      try {
        const result = await dispatch(getAllCancelReasons())

        if (mounted) {
          if (getAllCancelReasons.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      }
    }
    if (loadReasons) execute()

    return () => {
      mounted = false
    }
  }, [dispatch, loadReasons])

  return status
}
